import api from '../store/axiosConfig';
import { store } from '../store/store';

const MAX_FREE_COLLECTIONS = 5;
const MAX_FREE_FLASHCARDS = 10;

interface CreateCollectionData {
  title: string;
  description: string;
  category?: string;
}

export const collectionsService = {
  async getCollections() {
    const response = await api.get('/collections');
    return response.data;
  },

  async getCollection(id: string) {
    const response = await api.get(`/collections/${id}`);
    return response.data;
  },

  async createCollection(data: CreateCollectionData) {
    const state = store.getState();
    const user = state.auth.user;

    const response = await api.get('/stats');
    const stats = response.data;

    if (!user?.isPremium && stats.collectionsCreated >= MAX_FREE_COLLECTIONS) {
      throw new Error(`Free users can only create up to ${MAX_FREE_COLLECTIONS} collections. Upgrade to premium for unlimited collections!`);
    }

    const createResponse = await api.post('/collections', data);
    return createResponse.data;
  },

  async updateCollection(id: string, data: CreateCollectionData) {
    const response = await api.put(`/collections/${id}`, data);
    return response.data;
  },

  async deleteCollection(id: string) {
    const response = await api.delete(`/collections/${id}`);
    return response.data;
  },

  async addFlashcard(collectionId: string, data: { question: string; answer: string }) {
    const state = store.getState();
    const user = state.auth.user;
    const collection = state.collections.collections.find(c => c._id === collectionId);

    if (!user?.isPremium && collection && collection.flashcardCount >= MAX_FREE_FLASHCARDS) {
      throw new Error(`Free users can only create up to ${MAX_FREE_FLASHCARDS} flashcards per collection. Upgrade to premium for unlimited flashcards!`);
    }

    const response = await api.post(`/collections/${collectionId}/flashcards`, data);
    return response.data;
  }
};
